<p-fileUpload
  mode="basic"
  [auto]="true"
  [chooseLabel]="label"
  name="file"
  url="/api/v1/file/multiple"
  (onUpload)="onUpload($event)"
  [multiple]="true"
  [accept]="accept"
  [maxFileSize]="10000000"
>
</p-fileUpload>
